import { render, staticRenderFns } from "./pdfStandard.vue?vue&type=template&id=32f71d7c&scoped=true"
import script from "./pdfStandard.vue?vue&type=script&lang=js"
export * from "./pdfStandard.vue?vue&type=script&lang=js"
import style0 from "./pdfStandard.vue?vue&type=style&index=0&id=32f71d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f71d7c",
  null
  
)

export default component.exports